import { Typography } from "@mui/material";

import AppDialog from "./AppDialog";
import CustomButton from "./CustomButton";

interface ConfirmDialogProps {
  open: boolean;
  title: string;
  message: React.ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  onConfirm: () => void;
  onCancel: () => void;
  loading?: boolean;
}

/**
 * Project-styled confirmation modal (built on AppDialog) - the in-app
 * replacement for the native ``window.confirm``. Pass a string or custom node
 * as ``message``.
 */
export default function ConfirmDialog({
  open,
  title,
  message,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  onConfirm,
  onCancel,
  loading = false,
}: ConfirmDialogProps) {
  return (
    <AppDialog
      open={open}
      // While it runs, closing would only hide the work, not stop it.
      onClose={loading ? () => undefined : onCancel}
      title={title}
      showCloseIcon
      actions={
        <>
          <CustomButton fullWidth={false} onClick={onCancel} disabled={loading}>
            {cancelLabel}
          </CustomButton>
          <CustomButton
            fullWidth={false}
            onClick={onConfirm}
            disabled={loading}
          >
            {confirmLabel}
          </CustomButton>
        </>
      }
    >
      {typeof message === "string" ? (
        <Typography variant="body2">{message}</Typography>
      ) : (
        message
      )}
    </AppDialog>
  );
}
